import { Button } from '@/components/button';
import { MaterialSymbolIcon } from '@/components/material-symbol-link';
import styles from './photo-wrapper.module.css';
import { useState } from 'react';
import { Modal } from '@/components/modal/modal';
import { useTranslation } from '@/contexts/i18n-context';
import { useEncounter } from '@/contexts/encounter-context';
import { useDeleteEncountersImages } from '@/api/delete-image';
import { ModalButtons } from '@/components/modal/modal-buttons';

interface DeleteImageButtonProps {
  imageId: number;
  onDelete?: () => void;
}

export function DeleteImageButton({ onDelete, imageId }: DeleteImageButtonProps) {
  const { t } = useTranslation();
  const { mutate: deletePhoto } = useDeleteEncountersImages();
  const { encounter } = useEncounter();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDelete = () => {
    deletePhoto({
      encounterId: encounter.id,
      imageId: imageId,
    });
    onDelete?.();
  };

  return (
    <>
      <Button
        variant="textOnly"
        onClick={() => setIsModalOpen(true)}
        className={styles.deleteButton}
      >
        <MaterialSymbolIcon name="close" className={styles.deleteIcon} />
      </Button>
      <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <h2 className="h4">{t('visit.photoUpload.deleteImage.title')}</h2>

        <ModalButtons
          confirm={{
            text: t('common.yes'),
            onClick: handleDelete,
          }}
          cancel={{
            text: t('common.no'),
            onClick: () => setIsModalOpen(false),
          }}
        />
      </Modal>
    </>
  );
}
